export const dialogActionTranslations = {
  de: { "Action failed": "Die Aktion ist fehlgeschlagen. Bitte versuche es erneut." },
  en: { "Action failed": "The action failed. Please try again." },
  ru: { "Action failed": "Действие не выполнено. Повторите попытку." },
  uk: { "Action failed": "Дію не виконано. Спробуйте ще раз." },
  it: { "Action failed": "L’operazione non è riuscita. Riprova." },
} as const;
